import axios, { AxiosResponse } from 'axios'

import {
  CSReservationCreateWrite,
  CSReservationId,
  CSReservationRead,
  CSReservationWrite,
} from '@generated/types'

const BASE = '/api/csreservation'

export default {
  async updateCSReservation(
    id: CSReservationId,
    data: CSReservationWrite,
  ): Promise<AxiosResponse<CSReservationRead>> {
    return axios.put(`${BASE}/${id}/`, data)
  },

  async createCSReservation(
    data: CSReservationCreateWrite,
  ): Promise<AxiosResponse<CSReservationRead>> {
    return axios.post(`${BASE}/`, data)
  },

  async getCSReservation(id: number): Promise<AxiosResponse<CSReservationRead>> {
    return axios.get(`${BASE}/${id}/`)
  },
}
